import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { XenaClient } from 'src/app/services';
import { ICurrency } from 'src/app/xena-api/dtos';
import { IListOptionsFilter, defaultListOptionsFilter } from 'src/app/xena-api/filters';
import { Page } from 'src/app/xena-api/response-types';

@Injectable({
  providedIn: 'root',
})

export class CurrencyService {

  constructor(private xenaClient: XenaClient) {
  }

  list(filter: IListOptionsFilter = defaultListOptionsFilter): Observable<Page<ICurrency>> {
    const resourcePath: string = '/Home/GetDefaultCurrencyList';
    return this.xenaClient.list<ICurrency, IListOptionsFilter>(resourcePath, filter);
  }
}
